module.exports = __webpack_public_path__ + "ed3b92b87d7775f8cc36110ab2f5c1c4.jpg";